export default __webpack_public_path__ + "static/media/404_WEB_BANNER_1600x480.64e1fbd7.jpg";